/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UndistributeSkillRequestBody,
  UndistributeSkillRequestBody$Outbound,
  UndistributeSkillRequestBody$outboundSchema,
} from "../components/undistributeskillrequestbody.js";

export type UndistributeSkillSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UndistributeSkillSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UndistributeSkillSecurity = {
  option1?: UndistributeSkillSecurityOption1 | undefined;
  option2?: UndistributeSkillSecurityOption2 | undefined;
};

export type UndistributeSkillRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  undistributeSkillRequestBody: UndistributeSkillRequestBody;
};

/** @internal */
export type UndistributeSkillSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UndistributeSkillSecurityOption1$outboundSchema: z.ZodMiniType<
  UndistributeSkillSecurityOption1$Outbound,
  UndistributeSkillSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function undistributeSkillSecurityOption1ToJSON(
  undistributeSkillSecurityOption1: UndistributeSkillSecurityOption1,
): string {
  return JSON.stringify(
    UndistributeSkillSecurityOption1$outboundSchema.parse(
      undistributeSkillSecurityOption1,
    ),
  );
}

/** @internal */
export type UndistributeSkillSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UndistributeSkillSecurityOption2$outboundSchema: z.ZodMiniType<
  UndistributeSkillSecurityOption2$Outbound,
  UndistributeSkillSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function undistributeSkillSecurityOption2ToJSON(
  undistributeSkillSecurityOption2: UndistributeSkillSecurityOption2,
): string {
  return JSON.stringify(
    UndistributeSkillSecurityOption2$outboundSchema.parse(
      undistributeSkillSecurityOption2,
    ),
  );
}

/** @internal */
export type UndistributeSkillSecurity$Outbound = {
  Option1?: UndistributeSkillSecurityOption1$Outbound | undefined;
  Option2?: UndistributeSkillSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UndistributeSkillSecurity$outboundSchema: z.ZodMiniType<
  UndistributeSkillSecurity$Outbound,
  UndistributeSkillSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UndistributeSkillSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UndistributeSkillSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function undistributeSkillSecurityToJSON(
  undistributeSkillSecurity: UndistributeSkillSecurity,
): string {
  return JSON.stringify(
    UndistributeSkillSecurity$outboundSchema.parse(undistributeSkillSecurity),
  );
}

/** @internal */
export type UndistributeSkillRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UndistributeSkillRequestBody: UndistributeSkillRequestBody$Outbound;
};

/** @internal */
export const UndistributeSkillRequest$outboundSchema: z.ZodMiniType<
  UndistributeSkillRequest$Outbound,
  UndistributeSkillRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    undistributeSkillRequestBody: UndistributeSkillRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      undistributeSkillRequestBody: "UndistributeSkillRequestBody",
    });
  }),
);

export function undistributeSkillRequestToJSON(
  undistributeSkillRequest: UndistributeSkillRequest,
): string {
  return JSON.stringify(
    UndistributeSkillRequest$outboundSchema.parse(undistributeSkillRequest),
  );
}
